import React from 'react';
import styled from 'styled-components';

import { Offer } from '../Offer';

const OfferBox = styled.div`
    display: none;

    ${props => props.theme.mediaQueries.desktop} {
        display: block;
        border-radius: 35px;
        box-shadow: 0 0 50px 0 rgba(81, 129, 186, 0.25);
        background-color: ${props => props.theme.color.white};
        padding: 21px 15px 40px 15px;
        width: 270px;
    };
`;
export default (props) => (
    <OfferBox>
        <Offer
            {...props}
        />
    </OfferBox>
);